// extracted by mini-css-extract-plugin
export default {"block":"OnboardingBlockWrapper_block__rW-pK","hideButton":"OnboardingBlockWrapper_hideButton__Trc1R"};